module.exports = __webpack_public_path__ + "media/images/mailer/badge_2-05d684711d3d28493ad90bb3623f3e3b.png";